import styled from 'styled-components'

export const StyledLayout = styled.div`
  /* Root: fill the viewport and prevent the page itself from scrolling */
  display: flex;
  flex-direction: column;
  height: 100vh;         /* lock to viewport height */
  min-height: 100vh;
  overflow: hidden;      /* critical: no page scroll; scroll happens only in content area */

  /* On phones and tablets, 100vh is the viewport as it would be with the
     browser's URL/toolbar COLLAPSED — i.e. taller than what you can actually
     see. Combined with the overflow: hidden above, that pushed the bottom
     ~60-100px of this box (the footer, and the last rows of the scroll area)
     permanently under the browser chrome, where no amount of scrolling could
     reach it: the page itself can't scroll by design.

     dvh is the *dynamic* viewport height, which tracks the visible area. On
     desktop there is no collapsing chrome, so dvh and vh are always equal and
     this changes nothing — it only matters where the bug was. */
  @supports (height: 100dvh) {
    height: 100dvh;
    min-height: 100dvh;
  }

  /* The container between header and footer */
  #layout-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;      /* take all remaining space between header and footer */
    min-height: 0;       /* critical for flex children to be allowed to shrink and scroll */
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;

    /* Don't clip scrollbars here; the inner scroll area will manage scroll */
    overflow: visible;
  }

  /* If you use this row to hold the main area, ensure it can shrink */
  #content-row {
    flex: 1 1 auto;
    min-height: 0;
  }

  /* The ONLY scrollable area. It will always be visible between header and footer. */
  .content-scrollable {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;

    /* Vertical scroll when tall; horizontal scrollbar is ALWAYS visible */
    overflow-y: auto;
    overflow-x: scroll;            /* <- always show horizontal scrollbar */
    scrollbar-gutter: stable both-edges;

    /* Optional: if content includes wide tables/inline blocks and you prefer a single line */
    /* white-space: nowrap; */

    /* iOS smooth scrolling */
    -webkit-overflow-scrolling: touch;
  }
`

export const LayoutContainer = styled.div`
  /* Make this a vertical wrapper that stretches between header and footer */
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;                   /* allows child (.content-scrollable) to create scroll */

  /* Ensure full-width usage */
  align-items: stretch;
  justify-content: flex-start;

  padding: 10px 10px;
  width: 100%;
  box-sizing: border-box;

  /* Do not create scrollbars on this container—keep them in .content-scrollable */
  overflow: visible;

  /* If you previously needed wrapping, consider removing it to avoid growing height */
  /* flex-flow: wrap; */
`